<template>
  <div class="container-wrap" v-if="setting.state" v-wechat-title="$route.meta.title= pageTitle">
    <!-- 标题 -->
   <div class="bargain-title">
      <barTitle :curUrlKey="curUrlKey" :titleText="titleText" :username="username" />
      <div class="link-rule" @click="gotoRule" v-if="act_info.text == 1">活动规则</div>
   </div>

    <!-- 头部 -->
    <div class="top-placeholder" :style="{ background: colorFirst }">
      <inform v-if="setting.top" :informList="informList" />
      <div class="rag-container" v-if="dynamic_info" @click="handleTagOpen">
        规格：{{ dynamic_info.param_combination }}
      </div>
      <div class="link-order" @click="gotoOrder">我的砍价订单 ></div>
      <!-- <router-link to="/bargainRule" class="link-rule"></router-link> -->
    </div>
    <!-- 卡片 -->
    <div class="bargain-card">
      <div class="card-container">
        <img class="avatar" :src="user_info.user_pic" />
        <div class="discount">
          <span class="text">已砍</span>
          <span class="num">{{ act_handle.help_money }}</span>
          <span class="text">元</span>
        </div>
        <div class="goods" @click="gotoGoodsInfo">
          <div class="goods-image">
            <img :src="act_info.activity_pic" />
          </div>
          <div class="goods-info">
            <div class="goods-name">{{ act_info.activity_name }}</div>
            <div class="goods-fixed-price">
              单买价 {{currencySymbol}}{{ act_handle.unit_price }}
            </div>
            <div class="goods-floor-price">
              <span>可砍价至</span>
              <span>{{currencySymbol}}</span>
              <span class="integer-price">
                {{ act_handle.help_pro_money }}</span
              >
            </div>
            <div>
              <img
                src="../../../static/images/bargain/failed.png"
                class="failed"
                v-if="act_info.act_state == 3 || act_info.act_state == 5"
              />
              <img
                src="../../../static/images/bargain/success.png"
                class="success"
                v-if="act_info.act_state == 4 || (act_info.act_state == 8 && join_info.is_success == 1) || (act_info.act_state == 7 && dingdan_info)"
              />
            </div>
          </div>
        </div>

        <!-- 参与后显示 start -->
        <div v-if="act_info.act_state == 1">
          <div class="count-down-content">
            <div class="text">剩余</div>
            <div class="count-down">
              <div class="num" :style="{ background: colorFirst }">
                {{ hour }}
              </div>
              <div class="letter">:</div>
              <div class="num" :style="{ background: colorFirst }">
                {{ minute }}
              </div>
              <div class="letter">:</div>
              <div class="num" :style="{ background: colorFirst }">
                {{ second }}
              </div>
            </div>
            <div class="text">结束</div>
          </div>
        </div>

        <!-- 支付后显示 -->
        <div v-if="join_info">
          <div class="bargain-success-text" v-if="act_info.act_state == 4">
            已砍至最低价{{ act_handle.help_pro_money }}元
          </div>
          <div class="count-down-content" v-if="act_info.act_state == 5">
            <div class="text">砍价失败</div>
          </div>
          <div class="count-down-content" v-if="act_info.act_state == 7">
            <div class="text">砍价成功</div>
          </div>
          <div class="count-down-content" v-if="act_info.act_state == 2">
            <div class="text" v-if="!clearTimer">剩余支付时间</div>
            <div class="count-down" v-if="!clearTimer">
              <div class="num" :style="{ background: colorFirst }">
                {{ hour }}
              </div>
              <div class="letter">:</div>
              <div class="num" :style="{ background: colorFirst }">
                {{ minute }}
              </div>
              <div class="letter">:</div>
              <div class="num" :style="{ background: colorFirst }">
                {{ second }}
              </div>
            </div>
            <div class="text" v-if="clearTimer">活动已结束</div>
          </div>
        </div>

        <!-- 按钮状态 -->
        <!-- 喊好友砍一刀: 参与 -->
        <button class="handle-button" v-if="act_info.act_state == 0" :style="{ background: colorFirst }" @click="handleBargain"> 立即参与砍价 </button>
        <!-- 喊好友砍一刀: 分享 -->
        <button class="handle-button" v-if="act_info.act_state == 1" :style="{ background: colorFirst }" @click="handleShare"> 喊好友砍一刀 </button>
        <!-- 待支付 -->
        <button class="handle-button" v-if="act_info.act_state == 2" :style="{ background: colorFirst }" @click="gotoPay"> 待支付 </button>
        <!-- 支付失败 -->
        <button class="handle-button disabled" v-if="act_info.act_state == 3"> 支付失败 </button>
        <!-- 砍价成功显示 -->
        <button class="handle-button" v-if="act_info.act_state == 4" :style="{ background: colorFirst }" @click="gotoPay"> 砍价成功 立即购买 </button>
        <!-- 砍价失败 -->
        <button class="handle-button disabled" v-if="act_info.act_state == 5"> 砍价失败 </button>
        <!-- 帮好友砍价 --> 
        <button class="handle-button" v-if="act_info.act_state == 6" :style="{ background: colorFirst }" @click="handleHelped"> 帮他砍一刀 </button> 
        <!-- 更多砍价商品 -->
        <button class="handle-button" v-if="act_info.act_state == 7" :style="{ background: colorFirst }" @click="gotoList" >更多砍价商品</button>
        <!-- 我也要砍价拿货 --> 
        <button class="handle-button" v-if="act_info.act_state == 8" :style="{ background: colorFirst }" @click="handleBargainToo"> 我也要砍价拿货 </button> 

        <!-- 卡片底部 -->
        <div class="footer space-center">
          <!-- 邀请好友砍价后显示 start -->
          <!-- <div class="now" v-if="(!clearTimer && join_info) && (act_info.act_state == 0 || act_info.act_state == 1)"> -->
          <div class="now" v-if="!clearTimer && join_info && (act_info.act_state == 1) && ( (act_info.floor_price_buy == 1 && join_info.is_success == 1) || act_info.floor_price_buy != 1 )">
            <div class="now-price">
              <span>当前价格</span>
              <span>{{currencySymbol}}{{join_info.bargain_money}}</span>
            </div>
            <div class="now-buy" @click="handleBuyOpen">立即购买</div>
          </div>
          <!-- 邀请好友砍价后显示 end -->
          <div class="link-order-info" v-if="join_info.is_buy > 0" @click="gotoOrderInfo">订单详情 ></div>
        </div>

      </div>
    </div>
    <!-- 砍价记录 -->
    <history :helpList="helpList" :isShowMore="isShowMore" @handleMoreHelpList="handleMoreHelpList" />
    <!-- 商品推荐 -->
    <recommend :recommendList="recommendList" :colorFirst="colorFirst" :username="username" :currencySymbol="currencySymbol" />
    <!-- 分享弹窗 -->
    <div class="share-container" @touchmove.prevent>
      <div
        class="layer-container"
        :class="[shareShow ? 'opacity' : '']"
        @click="handleCloseLayer"
      ></div>
      <div class="share-canvas" v-if="shareShow">
        <img class="share-canvas-img" :src="wap_img_src" alt="">
        <div class="title">长按保存图片</div>
      </div>
      <div class="popup" :class="[shareShow ? 'open' : '']">
        <div class="popup-wrap">
          <div class="popup-content">
            <!-- <div
              class="item"
              v-clipboard:copy="copyUrl"
              v-clipboard:success="onCopySucc"
              v-clipboard:error="onCopyError"
            >
              <img src="../../../static/images/bargain/icon-link.png" />
              <span class="text">复制链接</span>
            </div> -->
            <div
              class="text"
              v-clipboard:copy="copyUrl"
              v-clipboard:success="onCopySucc"
              v-clipboard:error="onCopyError"
            >复制链接</div>
          </div>
          <div class="close" @click="handleCloseLayer">取消</div>
        </div>
      </div>
    </div>
    <!-- 砍价弹窗 -->
    <div class="bargain-modal" catchtouchmove="preventTouchMove" v-if="help_info" >
      <div
        class="layer-container"
        :class="[successShow ? 'opacity' : '']"
        @click="handleCloseLayer"
      ></div>
      <img
        class="icon-sun"
        v-if="successShow"
        src="../../../static/images/bargain/icon-sun.png"
      />
      <div class="bargain-content" v-if="successShow">
        <img
          class="icon-bargain"
          src="../../../static/images/bargain/icon-bargain.png"
        />
        <div class="bargain-content-save">
          <div class="bargain-content-save-text">帮砍成功</div>
          <div class="bargain-content-save-text">
            <span>砍掉</span>
            <span class="bcst-money">{{ help_info.help_price }}</span>
            <span>元</span>
          </div>
        </div>
        <div class="bargain-content-integral">
          <div class="bargain-content-integral-text" v-if="help_info.xf_jifen">
            <span>可获得</span>
            <span class="bcit-num">{{ help_info.xf_jifen }}消费积分</span>
          </div>
          <div class="bargain-content-integral-text" v-if="help_info.hd_jifen">
            <span>可获得</span>
            <span class="bcit-num">{{ help_info.hd_jifen }}互动积分</span>
          </div>
          <div class="bargain-content-integral-text" v-if="help_info.hongbao">
            <span>可获得</span>
            <span class="bcit-num">{{ help_info.hongbao }}元红包</span>
          </div>
        </div>
        <div class="bargain-content-handle" :style="{'justify-content': isGotoCenter ? 'center' : 'center'}">
          <div class="bch-btn" @click="handleCloseLayer">我知道了</div>
        </div>
      </div>
    </div>
    <!-- 购买弹窗 -->
    <div class="buy-modal">
      <div
        class="layer-container"
        :class="[buyShow ? 'opacity' : '']"
        @click="handleCloseLayer"
      ></div>
      <div class="buy-content" v-if="buyShow">
        <img
          @click="handleCloseLayer"
          class="bm-close"
          src="../../../static/images/bargain/icon-close.png"
        />
        <div class="bm-text1">
          确定以当前价格{{ join_info.bargain_money }}元购买？
        </div>
        <div class="bm-text2">
          该活动最低价格为{{
            act_handle.help_pro_money
          }}元，建议砍至底价后购买更优惠！
        </div>
        <div class="bm-handle">
          <div
            class="bmh-btn"
            @click="handleCloseLayer"
            :style="{ background: colorFirst }"
          >
            继续砍价
          </div>
          <div class="bmh-btn" :style="{ background: colorFirst }" @click="gotoPay">
            立即购买
          </div>
        </div>
      </div>
    </div>
    <!-- 规格弹窗 -->
    <div class="tag-modal" @touchmove.prevent>
      <div
        class="layer-container"
        :class="[tagShow ? 'opacity' : '']"
        @click="handleCloseLayer"
      ></div>
      <div class="popup" :class="[tagShow ? 'open' : '']">
        <div class="popup-wrap">
          <div class="title">产品属性</div>
          <div class="popup-content">
            <div class="tag-item" v-for="item in assemble_guige" :key="item.title">
              <div class="tag-title">{{item.title}}</div>
              <div class="tag-desc">{{item.content}}</div>
            </div>
            
          </div>
          <div class="close" @click="handleCloseLayer">取消</div>
        </div>
      </div>
    </div>

    <!-- 自己砍价弹窗 -->
    <div class="bargain-modal" catchtouchmove="preventTouchMove" >
      <div
        class="layer-container"
        :class="[mySuccessShow ? 'opacity' : '']"
        @click="handleCloseLayer"
      ></div>
      <img
        class="icon-sun"
        v-if="mySuccessShow"
        src="../../../static/images/bargain/icon-sun.png"
      />
      <div class="bargain-content" v-if="mySuccessShow">
        <img
          class="icon-bargain"
          src="../../../static/images/bargain/icon-bargain.png"
        />
        <div class="bargain-content-save">
          <div class="bargain-content-save-text">
            <span>你已砍掉</span>
            <span class="bcst-money">{{my_help_price}}</span>
            <span>元</span>
          </div>
        </div>
        <div class="bargain-content-integral">
          <div class="bargain-content-title">邀请好友帮我砍价</div>
        </div>
        <div class="bargain-content-handle" :style="{'justify-content': isGotoCenter ? 'center' : 'center'}" style="margin-top:0.5rem;">
          <div class="bch-btn" @click="handleShare">喊好友砍一刀</div>
        </div>
        <div class="close-img" @click="handleCloseLayer">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/website/wap_bargain/bargain_close_button.png" alt="">
        </div>
      </div>
      
    </div>

    <!-- <div class="pagination">
      <button class="page-btn" @click="prevPage">上一页</button>
      <button class="page-btn" @click="nextPage">下一页</button>
    </div> -->
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import qs from 'qs';
import barTitle from "./components/Title";
import inform from "./components/Inform";
import history from "./components/History";
import recommend from "./components/Recommend";
export default {
  name: "bargaining",
  data() {
    return {
      pageTitle: "微砍价",
      titleText: "砍价详情", // 标题文字
      curUrlKey: 'bargaining',// 路径来源
      roundTarget: 0, //本场倒计时时间戳
      day: "00",
      hour: "00",
      minute: "00",
      second: "00",
      clearTimer: false, // 倒计时是否停止
      shareShow: false, // 分享弹窗
      successShow: false, // 砍价弹窗
      buyShow: false, // 购买弹窗
      isBargaining: false, // 商品是否开启砍价
      isGotoCenter: true, // 是否显示立即查看
      tagShow: false, // 规格弹窗
      isHelpBargain: false,
      mySuccessShow: false,// 自己砍价弹窗
      page: 1, // 页码
      setting: {}, // 设置信息
      colorFirst: "", // 主色
      colorLast: "", // 副色
      currencySymbol: "",// 金钱符号
      helpList: [], // 帮砍记录
      recommendList: [], // 推荐商品
      informTimer: null, // 滚动栏定时器
      informList: [], // 滚动栏信息
      copyUrl: "", // 复制的链接

      username: "", //	网站用户名
      zz_userid: "", // 登录用户ID
      zz_shellCode: "", // 登录用户验证码
      act_id: "", //活动ID
      act_info: {}, // 活动基本信息
      order_info: {}, // 订单基本信息
      act_handle: {}, // 活动计算整理后信息
      join_info: {}, // 参与信息
      user_info: {}, //用户信息
      pro_info: {}, //商品信息
      dynamic_info: {}, //商品规格
      join_id: "", // 参与id
      assemble_guige: [], // 规格信息
      dingdan_info: "", // 订单信息
      help_info: "", // 帮砍信息
      order: 0, // 是否从订单页进入
      domain: "", // 域名
      port: "", // 协议
      baseUrl: "", // 基本路径
      historyPage: 1, // 砍价记录页码
      isShowMore: false, // 砍价记录加载更多图标
      wap_img_src: '', // 分享图地址
      fenxiao_info_code: 0,
      fenxiao_info_member_id: 0,
      my_help_price: '',// 自己砍价金额

    };
  },
  components: {
    inform,
    history,
    recommend,
    barTitle
  },
  updated() {
    this._layer2my("closeAll", "loading");
  },
  created() {
    if (document.location.protocol == "https:") {
      this.port = ":12702";
    } else {
      this.port = ":12701";
    }
    this.domain = document.domain;
    // this.domain = "m.evyun.cn";
    this.baseUrl = this.domain + this.port;

    // 获取cookie
    let cookieArg = this.getCookieStringArgs();
    // 获取query
    let queryArg = this.getQueryStringArgs();
    this.username = queryArg["username"];
    this.act_id = queryArg["act_id"] ? queryArg["act_id"] : queryArg["actId"];
    this.join_id = queryArg["join_id"] ? queryArg["join_id"] : 0;
    this.order = queryArg["order"] ? queryArg["order"] : 0;
    this.zz_userid = cookieArg["zz_userid"];
    this.zz_shellCode = cookieArg["zz_shellCode"];



    // TODO 获取当前页面 Url 
    // this.copyUrl = `${window.location.href}&code=${this.fenxiao_info_code}&member_id=${this.fenxiao_info_member_id}`;
  },
  mounted() {
    // 设置 & 详情
    this.reloadAll();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.informTimer);
  },
  methods: {
    /****************** 倒计时 *********************/
    // 倒计时
    init() {
      const self = this;
      setTimeout(function() {
        self.getLastTime.call(self);
      }, 1000);
    },
    getLastTime() {
      const gapTime = Math.ceil(
        (this.roundTarget - new Date().getTime()) / 1000
      );
      let day = "00";
      let hour = "00";
      let minute = "00";
      let second = "00";
      if (gapTime > 0) {
        day = this.formatNum(parseInt(gapTime / 86400));
        // let lastTime = gapTime % 86400; // 不需要天
        let lastTime = gapTime;
        hour = this.formatNum(parseInt(lastTime / 3600));
        lastTime = lastTime % 3600;
        minute = this.formatNum(parseInt(lastTime / 60));
        second = this.formatNum(lastTime % 60);
        if (!this.clearTimer) this.init.call(this);
      } else {
        this.endfn();
      }
      this.day = day;
      this.hour = hour;
      this.minute = minute;
      this.second = second;
    },
    // 本场砍价倒计时结束回调
    endfn() {
      this.clearTimer = true;
      this.reloadAll();
    },
    // 倒计时时间格式化
    formatNum(num) {
      return num > 9 ? num : `0${num}`;
    },
    /****************** 跳转  *********************/
    // 跳转规则页面
    gotoRule() {
      const act_id = this.act_id;
      const username = this.username;
      this.$router.push({ path: "/bargainRule", query: { act_id, username } });
    },
    // 跳转订单页面
    gotoOrder() {
      const that = this;
      let queryArg = that.getQueryStringArgs();
      const zz_userid = that.zz_userid;
      const username = that.username;
      const zz_shellCode = that.zz_shellCode;
      const color = that.colorFirst.slice(1);
      const join_id = that.join_id;
      const act_id = that.act_id;
      const currencySymbol = that.currencySymbol;
      const fenxiao_info_code = that.fenxiao_info_code ? that.fenxiao_info_code : queryArg["code"];
      const fenxiao_info_member_id = that.fenxiao_info_member_id ? that.fenxiao_info_member_id : queryArg["member_id"];
      const backUrl = `${location.href.split('?')[0]}?username=${username}|act_id=${act_id}|join_id=${join_id}`;
      // 如果拿不到cookie中的zz_userid，跳转登录
      if (!zz_userid) {
        that._layer2my(
              "confirm",
              "登录后可查看我的订单，点击确认跳转登录页",
              function() {
                const params = {
                    username: username,
                    act_id: that.act_id,
                    join_id: that.join_id,
                    zz_userid: that.zz_userid,
                    zz_shellCode: that.zz_shellCode,
                    code: fenxiao_info_code,
                    member_id: fenxiao_info_member_id
                  };
                // 判断是否是微信环境
                that.isWeiXin(()=>{
                  that.$axios
                    .get(`//${that.baseUrl}/Frontend/Bargain/weChat`, {
                      params: params
                    })
                    .then(res => {
                      res = res.data;
                      if (res.data && res.code == 200) {
                        location.replace(res.data.wxOauthUrl)
                      } else {
                        that._layer2my("msg", res.msg);
                      }
                  });
                },()=>{
                  location.href = `/dom/denglu.php?username=${that.username}&code=${fenxiao_info_code}&member_id=${fenxiao_info_member_id}&parsing=1&wap=1&trespass=${backUrl}`;
                })
              }
            );

        document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`
        return false;
      }

      this.$router.push({
        path: "/bargainOrder",
        query: { username }
      });
    },
    // 跳转分享图片
    gotoShare() {
      const act_id = this.act_id;
      const username = this.username;
      const zz_userid = this.zz_userid;
      const zz_shellCode = this.zz_shellCode;
      const join_id = this.join_id;
      const fenxiao_info_code = this.fenxiao_info_code;
      const fenxiao_info_member_id = this.color_first;
      this.$router.push({
        path: "/bargainShare",
        query: {
          username,
          act_id,
          zz_userid,
          zz_shellCode,
          join_id,
          code:fenxiao_info_code,
          member_id:fenxiao_info_member_id
        }
      });
    },
    // 更多砍价商品 跳转列表页
    gotoList() {
      const username = this.username;
      this.$router.push({
        path: "/bargainList",
        query: { username }
      });
    },
    // 跳转购买
    gotoPay() {
      this._layer2my("load");
      let that = this;
      const axparams = {
        username: that.username,
        zz_userid: that.zz_userid,
        zz_shellCode: that.zz_shellCode,
        act_id: that.act_id,
        join_id: that.join_id,
        order: that.order
      };
      // 如果拿不到cookie中的zz_userid，跳转登录
      if (!that.zz_userid) {
        location.href = `/dom/denglu.php?username=${that.username}&parsing=1&wap=1&trespass=${backUrl}`;
        return false;
      }

      // 重新请求详情，判断商品是否售罄
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainInfo`, {
          params: axparams
        })
        .then(res => {
          res = res.data;
          if (res.data && res.code == 200) {
            that._layer2my("closeAll", "loading");
            // 当前商品售罄跳转列表页
            if(res.data.act_handle.can_purchase <= 0) {
              that._layer2my( "confirm", "当前商品已售罄~", function(){
                that.gotoList();
              });
            document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

            }else {
              location.href = `/dom/sc_orderbuy.php?username=${that.username}&wap=1&orderType=bargain&bargain_join_id=${that.join_id}&actId=${that.act_id}`;
            }
          }
        })
      

    },
    // 跳转商品详情页
    gotoGoodsInfo() {
      location.href = `/${this.username}/wap_pro/${this.pro_info.pid}.html`
    },
    // 跳转会员中心
    gotoCenter(){
      location.href = `/dom/sc_user_center.php?username=${this.username}&wap=1`
    },
    // 订单详情
    gotoOrderInfo() {
      const that = this;
      location.href = `/dom/sc_order_detail.php?type=&id=${this.join_info.is_buy}&username=${this.username}&wap=1&bargain_join_id=${that.join_id}`
    },
    /****************** 操作 *********************/
    // 复制成功
    onCopySucc() {
      this.shareShow = false;
      this._layer2my("msg", "复制成功~");
    },
    // 复制失败
    onCopyError() {
      this.shareShow = false;
      this._layer2my("msg", "复制失败");
    },
    // 关闭弹窗
    handleCloseLayer() {
      this.shareShow = false;
      this.successShow = false;
      this.buyShow = false;
      this.tagShow = false;
      this.mySuccessShow = false;
    },
    // 购买弹窗
    handleBuyOpen() {
      this.buyShow = true;
    },
    // 规格弹窗
    handleTagOpen() {
      this.tagShow = true;
    },
    // 喊好友砍一刀 分享
    handleShare() {
      const that = this;
      const axparams = {
        username: that.username,
        act_id: that.act_id,
        zz_userid: that.zz_userid,
        zz_shellCode: that.zz_shellCode,
        join_id: that.join_id,
        code: that.code,
        number_id: that.number_id,
        type: 0
      };
      that.mySuccessShow = false;
      that._layer2my("load");
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainInfoShare`, { params: axparams })
        .then((res)=> {
          res = res.data;
          if (res.data && res.code == 200) {
              that.shareShow = true;
              that.wap_img_src = res.data.wap_img_src;
            } else {
              that._layer2my("msg", res.msg);
            }
        });
    },
    // 喊好友砍一刀 参与
    handleBargain() {
      let that = this;
      let queryArg = that.getQueryStringArgs();
      const fenxiao_info_code = that.fenxiao_info_code ? that.fenxiao_info_code : queryArg["code"];
      const fenxiao_info_member_id = that.fenxiao_info_member_id ? that.fenxiao_info_member_id : queryArg["member_id"];
      const bargainParams = {
        username: that.username,
        act_id: that.act_id,
        zz_userid: that.zz_userid,
        zz_shellCode: that.zz_shellCode,
        code: fenxiao_info_code,
        member_id: fenxiao_info_member_id,
        wap: 1
      };
      const params = {
        username: that.username,
        act_id: that.act_id,
        join_id: that.join_id,
        zz_userid: that.zz_userid,
        zz_shellCode: that.zz_shellCode,
        code: fenxiao_info_code,
        member_id: fenxiao_info_member_id
      }
      const backUrl = `${location.href.split('?')[0]}?username=${that.username}|act_id=${that.act_id}|join_id=${that.join_id}`;

      // 如果拿不到cookie中的zz_userid，跳转登录
      if (!bargainParams.zz_userid) {
        that._layer2my(
              "confirm",
              "登录后可参与砍价活动，点击确认跳转登录页",
              function() {
                // location.href = `/dom/denglu.php?username=${that.username}&parsing=1&wap=1&trespass=${backUrl}`;
                // 判断是否是微信环境
                that.isWeiXin(()=>{
                  that.$axios
                    .get(`//${that.baseUrl}/Frontend/Bargain/weChat`, {
                      params: params
                    })
                    .then(res => {
                      res = res.data;
                      if (res.data && res.code == 200) {
                        location.replace(res.data.wxOauthUrl)
                        // console.log(res.data.wxOauthUrl)
                      } else {
                        that._layer2my("msg", res.msg);
                      }
                  });
                },()=>{
                  location.href = `/dom/denglu.php?username=${that.username}&code=${fenxiao_info_code}&member_id=${fenxiao_info_member_id}&parsing=1&wap=1&trespass=${backUrl}`;
                })
              }
            );
        document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

        return false;
      }


      this._layer2my("load");
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/joinPartake`, {
          params: bargainParams
        })
        .then(res => {
          res = res.data;
          that._layer2my("closeAll", "loading");
          if (res.data && res.code == 200) {
            that._layer2my(
              "confirm",
              "恭喜！参与活动成功，快去邀请好友吧~",
              function() {
                that.join_id = res.data.join_id;
                that.my_help_price = res.data.help_info.help_price
                // let queryArg = that.getQueryStringArgs();
                // location.replace(
                //   `${location.origin}${location.pathname}?username=${queryArg['username']}&act_id=${that.act_id}&join_id=${res.data.join_id}`
                // );
                that.can_purchase = res.data.can_purchase;
                that.mySuccessShow = true;
                that.reloadAll();
              }
            );
            document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

            // sessionStorage.setItem("join_id",res.data.join_id);
          }else if(res.code == 7087 || res.code == 7059){
            that._layer2my(
              "confirm",
              res.msg,
              function() {
                that.join_id = res.param.join_id;
                let queryArg = that.getQueryStringArgs();
                location.replace(
                  `${location.origin}${location.pathname}?username=${queryArg['username']}&act_id=${that.act_id}&join_id=${that.join_id}`
                );
                that.reloadAll();
              }
            );
            document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

          }else if(res.code == 7096){
            that._layer2my(
              "confirm",
              res.msg,
              function() {
                location.href = res.param;
              }
            );
            document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

          } else {
            that._layer2my("msg", res.msg);
          }
        });
    },
    // 帮好友砍一刀
    handleHelped() {
      let that = this;
      that.isHelpBargain = true;
      let queryArg = that.getQueryStringArgs();
      const fenxiao_info_code = that.fenxiao_info_code ? that.fenxiao_info_code : queryArg["code"];
      const fenxiao_info_member_id = that.fenxiao_info_member_id ? that.fenxiao_info_member_id : queryArg["member_id"];
      const backUrl = `${location.href.split('?')[0]}?username=${that.username}|act_id=${that.act_id}|join_id=${that.join_id}`;
      const helpParams = {
        username: that.username,
        act_id: that.act_id,
        join_id: that.join_id,
        zz_userid: that.zz_userid,
        zz_shellCode: that.zz_shellCode
      };
      if (!that.join_id) {
        that._layer2my( "confirm", "参与ID有误！请重新通过分享进入");
        document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

        return false
      }
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/helpPartake`, { params: helpParams })
        .then((res)=> {
          res = res.data;
          if (res.data && res.code == 200) {
            that.help_info = res.data.help_info;
            that.successShow = true;
            that.reloadAll();
          } else if(res.code == 7074){
            that._layer2my(
              "confirm",
              res.msg,
              function() {
                const params = {
                    username: that.username,
                    act_id: that.act_id,
                    join_id: that.join_id,
                    zz_userid: that.zz_userid,
                    zz_shellCode: that.zz_shellCode,
                    code: fenxiao_info_code,
                    member_id: fenxiao_info_member_id
                  };
                // 判断是否是微信环境
                that.isWeiXin(()=>{
                  that.$axios
                    .get(`//${that.baseUrl}/Frontend/Bargain/weChat`, {
                      params: params
                    })
                    .then(res => {
                      res = res.data;
                      if (res.data && res.code == 200) {
                        location.replace(res.data.wxOauthUrl)
                        // console.log(res.data)
                      } else {
                        that._layer2my("msg", res.msg);
                      }
                  });
                },()=>{
                  location.href = `/dom/denglu.php?username=${that.username}&code=${fenxiao_info_code}&member_id=${fenxiao_info_member_id}&parsing=1&wap=1&trespass=${backUrl}`;
                })
              }
            );
            document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`
          } else {
            that._layer2my( "confirm", res.msg, function(){
              that.gotoList();
            });
            document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`
          }
        });

    },
    // 我也要砍价拿货
    handleBargainToo() {
      let that = this;
      const bargainParams = {
        username: that.username,
        act_id: that.act_id,
        zz_userid: that.zz_userid,
        zz_shellCode: that.zz_shellCode,
        wap: 1
      };
      const backUrl = `${location.href.split('?')[0]}?username=${that.username}|act_id=${that.act_id}`;
      if(!bargainParams.zz_userid) {
        that._layer2my(
              "confirm",
              "登录后可参与砍价活动，点击确认跳转登录页",
              function() {
                // location.href = `/dom/denglu.php?username=${that.username}&parsing=1&wap=1&trespass=${backUrl}`;
                that.isWeiXin(()=>{
                  that.$axios
                    .get(`//${that.baseUrl}/Frontend/Bargain/weChat`, {
                      params: bargainParams
                    })
                    .then(res => {
                      res = res.data;
                      if (res.data && res.code == 200) {
                        location.replace(res.data.wxOauthUrl)
                      }else {
                        that._layer2my("msg", res.msg);
                      }
                  });
                },()=>{
                  location.href = `/dom/denglu.php?username=${that.username}&code=${that.fenxiao_info_code}&member_id=${that.fenxiao_info_member_id}&parsing=1&wap=1&trespass=${backUrl}`;
                })
              }
            );
        document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`
            
        return false;
      }
      this._layer2my("load");
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/joinPartake`, {
          params: bargainParams
        })
        .then(res => {
          res = res.data;
          that._layer2my("closeAll", "loading");
          if (res.data && res.code == 200) {
            that._layer2my(
              "confirm",
              "恭喜！参与活动成功，快去邀请好友吧~",
              function() {
                that.join_id = res.data.join_id;
                location.replace(
                  location.href + `&join_id=${res.data.join_id}`
                );
                that.reloadAll();
              }
            );
          document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

          }else if(res.code == 7087 || res.code == 7059){
            that._layer2my(
              "confirm",
              res.msg,
              function() {
                that.join_id = res.param.join_id;
                let queryArg = that.getQueryStringArgs();
                location.replace(
                  `${location.origin}${location.pathname}?username=${queryArg['username']}&act_id=${that.act_id}&join_id=${that.join_id}`
                );
                that.reloadAll();
              }
            );
          document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

          } else if(res.code == 7096){
              that._layer2my(
                "confirm",
                res.msg,
                function() {
                  location.href = res.param;
                }
              );
              document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

          } else {
            that._layer2my("msg", res.msg);
          }
        });
    },
    // 加载更多砍价记录
    handleMoreHelpList() {
      this.historyPage += 1;
      this.getHelpList()
    },
    /****************** 请求 *********************/

    // [活动详情页]
    getBargainingInfo() {
      this._layer2my("load");
      const that = this;
      const axparams = {
        username: that.username,
        zz_userid: that.zz_userid,
        zz_shellCode: that.zz_shellCode,
        act_id: that.act_id,
        join_id: that.join_id,
        order: that.order
      };
      // TODO 打印参数，上线之前去掉
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainInfo`, {
          params: axparams
        })
        .then(res => {
          res = res.data;
          if (res.data && res.code == 200) {
            that._layer2my("closeAll", "loading");
            that.act_info = res.data.act_info;
            that.order_info = res.data.order_info;
            that.act_handle = res.data.act_handle;
            that.join_info = res.data.join_info;
            that.user_info = res.data.user_info;
            that.pro_info = res.data.pro_info;
            that.dynamic_info = res.data.dynamic_info;
            that.dingdan_info = res.data.dingdan_info;
            that.assemble_guige = res.data.assemble_guige;
            that.fenxiao_info_code = res.data.fenxiao_info.code;
            that.fenxiao_info_member_id = res.data.fenxiao_info.member_id;
            if(window.location.href.indexOf('join_id') > -1){
              that.copyUrl = `${window.location.href}&code=${that.fenxiao_info_code}&member_id=${that.fenxiao_info_member_id}`;
            }else {
              that.copyUrl = `${window.location.href}&join_id=${that.join_id}&code=${that.fenxiao_info_code}&member_id=${that.fenxiao_info_member_id}`;
            }

            // 微信分享
            this.getShareInfo()

            // 当前商品售罄跳转列表页
            if(res.data.act_handle.can_purchase <= 0 && res.data.act_info.act_state !== 7) {
              that._layer2my( "confirm", "当前商品已售罄~", function(){
                that.gotoList();
              });
              document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

            }

            // 未登录 匿名砍价 不显示立即查看
            if (!that.zz_userid) {
              that.isGotoCenter = false;
            }

            // 砍价记录
            if (res.data.join_info) {
              that.join_id = res.data.join_info.id;
              that.getHelpList();
            }
            
            // 参与倒计时
            // TODO 帮砍价用户 is_join == 1 是正确的吗？
            if (
              res.data.act_handle &&
              res.data.act_handle.is_join == 1 &&
              res.data.act_handle.count_down > 0
            ) {
              that.roundTarget = res.data.act_handle.count_down;
              // that.isBargaining = true;
              that.getLastTime();
            }
            // 订单倒计时
            if (
              res.data.dingdan_info &&
              res.data.dingdan_info.dingdan_over_time > 0
            ) {
              that.roundTarget =
                interfaceData.data.dingdan_info.dingdan_over_time;
              that.getLastTime();
            }
            // 推荐商品
            if (res.data.act_info && res.data.act_info.recommend == 1) {
              that.getRecommendGoods();
            }
          } else {
            let username = that.username;
            let zz_userid = that.zz_userid;
            let zz_shellCode = that.zz_shellCode;
            that._layer2my("confirm", res.msg, function() {
              that.$router.push({
                path: "/bargainList",
                query: { username, zz_shellCode }
              });
            });
            document.getElementsByClassName("layui-layer-btn0")[0].style.cssText = `background:${that.colorFirst};border-color:${that.colorFirst};`

          }
        });
    },
    // [设置]
    getSettingInfo() {
      let that = this;
      const axparams = {
        username: that.username
      };
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainSet`, {
          params: axparams
        })
        .then(res => {
          res = res.data;
          this._layer2my("closeAll", "loading");
          if (res.data && res.code == 200) {
            this.setting = res.data.list;
            this.currencySymbol = res.data.currencySymbol;
            // 开启顶部滚动栏
            if (this.setting.top == 1) {
              that.getJoinSuccessInfo();
            }
            switch (that.setting.color) {
              case 0:
                that.colorFirst = "#F61E1E";
                that.colorLast = "#F91808";
                break;
              case 1:
                that.colorFirst = "#0084FF";
                that.colorLast = "#00B4FF";
                break;
              case 2:
                that.colorFirst = "#FF9900";
                that.colorLast = "#FFBE32";
                break;
              case 3:
                that.colorFirst = "#0BB854";
                that.colorLast = "#54CD87";
                break;
              case 4:
                that.colorFirst = res.data.list.color_first;
                that.colorLast = res.data.list.color_second;
                break;
              default:
                that.colorFirst = "#F61E1E";
                that.colorLast = "#F91808";
                break;
            }
          } else {
            that._layer2my("msg", res.msg);
          }
        });
    },
    // 砍价记录
    getHelpList() {
      const that = this;
      const axparams = {
        username: that.username,
        act_id: that.act_id,
        join_id: that.join_id,
        zz_userid: that.zz_userid,
        zz_shellCode: that.zz_shellCode,
        page: that.historyPage
      };
      this.$axios
        .get(`//${that.baseUrl}/Frontend/Bargain/bargainHelpList`, {
          params: axparams
        })
        .then(res => {
          res = res.data;
          that._layer2my("closeAll", "loading");
          if (res.data && res.code == 200) {
            res.data.total > 5 ? that.isShowMore = true : that.isShowMore = false;
            // 是否显示加载更多图标
            if (res.data.list == '' || (res.data.list.length <= 5 && that.historyPage !== 1) ) {
              that.isShowMore = false;
            }
            // 击加载更多图标加载更多砍价记录
            if(res.data.list !== '' && !that.isHelpBargain) {
              that.helpList = that.helpList.concat(res.data.list);
            }
            // 帮好友砍价刷新砍价记录
            if(res.data.list !== '' && that.isHelpBargain) {
              that.helpList = res.data.list;
            }
          } else {
            that._layer2my("msg", res.msg);
          }
        });
    },
    // 获取[推荐商品]
    getRecommendGoods() {
      let that = this;
      const axparams = {
        username: that.username,
        act_id: that.act_id
      };
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainRecPro`, {
          params: axparams
        })
        .then(res => {
          res = res.data;
          if (res.data && res.code == 200) {
            that.recommendList = res.data.list;
          } else {
            that._layer2my("msg", res.msg);
          }
        });
    },
    // 获取[砍价成功信息]
    getJoinSuccessInfo() {
      let that = this;
      const succParams = {
        username: that.username
      };
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/joinSuccess`, {
          params: succParams
        })
        .then(res => {
          res = res.data;
          if (res.data && res.code == 200) {
            res.data.list ? that.informList = res.data.list : [];
          } else {
            that._layer2my("msg", res.msg);
          }
      });
    },

    // 微信分享
    getShareInfo() {
      const that = this;
      const params = {
        username: that.username
      };
      const act_info = that.act_info;
      const title = act_info.share_name ? act_info.share_name : act_info.activity_name;
      const pic = act_info.share_pic ? act_info.share_pic : act_info.activity_pic;
      const desc = act_info.share_info ? act_info.share_info : '快来参与微砍价吧~';
      this.$axios.post(`//${this.baseUrl}/Frontend/Bargain/bargainWxShare`,qs.stringify({
        username: that.username,
        url: location.href.split('#')[0]
      }),{
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then((res) => {
      let data = res.data.data.signPackage;
      wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
      })
      }).catch((error) => {
        console.log(error)
      })
      wx.ready((res) => {
        wx.updateTimelineShareData({
          title: title,
          link: location.href,
          imgUrl: pic,
          success () {

          }
        });
        wx.updateAppMessageShareData({
          title: title,
          desc: desc,
          link: location.href,
          imgUrl: pic,
          success () {
          }
        })
      })
    }, 
    /****************** 刷新数据 *********************/

    reloadAll() {
      this.getSettingInfo();
      this.getBargainingInfo();
    },
    /****************** 工具 *********************/

    // 查询字符串参数
    getQueryStringArgs() {
      var qs = location.search.length > 0 ? location.search.substring(1) : "",
        args = {},
        items = qs.length > 0 ? qs.split("&") : [],
        item = null,
        name = null,
        value = null,
        i = 0,
        len = items.length;
      for (i; i < len; i++) {
        item = items[i].split("=");
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length) {
          args[name] = value;
        }
      }
      return args;
    },
    // 查询cookie参数
    getCookieStringArgs() {
      const cs = document.cookie.length > 0 ? document.cookie.replace(/\s/g, "") : "";
      // const cs = this.getCookie().replace(/\s/g, ""); // 获取本地模拟cookies
      let args = {},
        items = cs.length > 0 ? cs.split(";") : [],
        item = null,
        name = null,
        value = null,
        i = 0,
        len = items.length;
      for (i; i < len; i++) {
        item = items[i].split("=");
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length) {
          args[name] = value;
        }
      }
      return args;
    },
    // 本地模拟获取cookie登录状态
    getCookie() {
      // 未登录
      // const cookies = "";
      // 别人
      // const cookies = "zz_userid=21062530;zz_shellCode=31d1791fe6c4d41cd202767760c9d581";
      // 自己
      const cookies = "zz_userid=21263772;zz_shellCode=c76676e680a08b9f0af490035b39396e;";
      return cookies;
    },
    isWeiXin(succfn,elsefn) {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        succfn()
      }else {
        elsefn()
      }
    },
    // 封装 layui
    _layer2my(type, str, cb, bargainParams) {
      const that = this;
      layui.use("layer", function() {
        layer.ready(function() {
          switch (type) {
            case "msg":
              layer.msg(str, { time: 1500 });
              break;
            case "load":
              layer.load({
                shade: true
              });
              break;
            case "confirm":
              layer.confirm(
                str,
                {
                  btn: ["确定"]
                },
                function() {
                  cb && cb(bargainParams);
                  layer.closeAll();
                }
              );
              break;
            case "closeAll":
              layer.closeAll(str);
              break;
            default:
              layer.msg(str, { time: 1500 });
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.container-wrap {
  margin: 0 auto;
  height: 100vh;
  background: #f8f8f8;
  overflow-x: hidden;
}
// 头部
.top-placeholder {
  position: relative;
  width: 100%;
  height: 3.2rem;
  background: #f61e1e;
  .link-order {
    position: absolute;
    top: 1rem;
    right: .4rem;
    color: #FFFFFF;
    font-size: .24rem;
  } 
}
// 规则链接
.link-rule {
  position: absolute;
  top: .31rem;
  right: 0.3rem;
  font-size: 0.24rem;
  color: #282828;
  z-index: 999;
}
// 规格标签
.rag-container {
  position: absolute;
  left: 0;
  top: 0.97rem;
}

/* 规格标签 */
.rag-container {
  max-width: 1.6rem;
  height: 0.4rem;
  padding: 0 0.2rem;
  line-height: 0.4rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0 0.2rem 0.2rem 0;
  font-size: 0.22rem;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 砍价卡片 */
.bargain-card {
  position: relative;
  margin-top: -1.6rem;
  .card-container {
    position: relative;
    margin: 0 auto;
    width: 6.7rem;
    min-height: 5rem;
    background: #fff;
    border-radius: 0.2rem;
    padding-bottom: 0.37rem;
    .avatar {
      position: absolute;
      left: 50%;
      top: -0.64rem;
      transform: translateX(-50%);
      display: block;
      width: 1.28rem;
      height: 1.28rem;
      border-radius: 50%;
      box-shadow: 0 0.05rem 0.15rem 0 rgba(51, 51, 51, 0.08);
    }
    .discount {
      padding-top: 0.85rem;
      text-align: center;
      font-size: 0.28rem;
      line-height: 0.28rem;
      .text {
        color: #333;
      }
      > .num {
        color: #e51722;
      }
    }
    .bargain-success-text {
      margin-top: 0.44rem;
      text-align: center;
      font-size: 0.24rem;
    }
    .goods {
      width: 6.3rem;
      height: 2.1rem;
      padding: 0.2rem;
      background: #fafafa;
      display: flex;
      box-sizing: border-box;
      margin: 0.3rem auto 0;
      .goods-image {
        flex: 0 0 1.7rem;
        width: 1.7rem;
        height: 1.7rem;
        margin-right: 0.25rem;
        border-radius: .12rem;
        overflow: hidden;
        > img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .goods-info {
        position: relative;
        flex: 1;
        .goods-name {
          font-size: 0.26rem;
          color: #111;
          overflow : hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          margin-bottom: 0.14rem;
        }
        .goods-fixed-price {
          color: #888;
          font-size: 0.24rem;
          lighting-color: 0.24rem;
          margin-bottom: 0.14rem;
        }
        .goods-floor-price {
          color: #e51722;
          line-height: 0.38rem;
          font-size: 0;
          span {
            font-size: 0.24rem;
          }
          span:first-child {
            color: #555;
            padding-right: 0.1rem;
          }
        }
        .integer-price {
          font-size: 0.38rem !important;
        }
      }
    }
    .handle-button {
      width: 5.2rem;
      height: 0.98rem;
      margin: 0.38rem auto 0;
      background: rgba(255, 46, 31, 1);
      border-radius: 0.06rem;
      font-size: 0.34rem;
      font-weight: 400;
      color: #fff;
      line-height: 0.98rem;
      border: none;
      display: block;
      &.disabled {
        background: #eeeeee;
        color: #888888;
      }
      &::after {
        border: none;
      }
    }
    .footer {
      margin-top: 0.35rem;
      display: flex;
      padding: 0 0.75rem;
      line-height: 0.24rem;
      
      .now {
        display: flex;
        font-size: 0.24rem;
        /* margin-right: .94rem; */
        .now-price {
          color: #888;
        }
        .now-price span + span {
          color: #222;
        }
        .now-buy {
          color: #ff9634;
          padding-left: 0.18rem;
        }
      }
    }
    .space-between {
      justify-content: space-between;
    }
    .space-center {
      justify-content: center;
    }
    .count-down-content {
      margin-top: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 0.32rem;
      .count-down {
        display: flex;
        margin: 0 0.12rem;
        .num {
          font-size: 0.22rem;
          color: #fff;
          width: 0.4rem;
          height: 0.32rem;
          text-align: center;
          line-height: 0.32rem;
          border-radius: 0.04rem;
          background: #f61e1e;
        }
        .letter {
          margin: 0 0.04rem;
          color: #888;
        }
      }
      .text {
        color: #888;
        font-size: 0.22rem;
      }
    }
    .success,
    .failed {
      position: absolute;
      top: -0.14rem;
      right: 0;
      width: 1.23rem;
      height: 1.23rem;
    }
  }
}
/* 弹窗 */
.layer-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.5s;
  opacity: 0;
  z-index: -1;
  &.opacity {
    opacity: 1;
    z-index: 99;
  }
}

/* 分享 */
.share-container {
  position: relative;
  .title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.24rem;
    color: #fff;
    margin-top: .4rem;
    &::after,
    &::before {
      content: "";
      display: block;
      width: 0.6rem;
      height: 1px;
      background: #ededed;
    }
    &::after {
      margin-left: 0.18rem;
    }
    &::before {
      margin-right: 0.2rem;
    }
  }
    .popup-content {
      width: 100%;
      margin: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: .3rem 2rem;
      box-sizing: border-box;
      .text {
        font-size: .28rem;
        color: #333;
      }
    }

  .item {
    position: relative;
    flex: 0 0 1.4rem;
    text-align: center;
    > img {
      display: block;
      width: 1.4rem;
      height: 1.3rem;
    }
    > text {
      font-size: 0.24rem;
      font-weight: 400;
      color: #333;
    }
  }
  .share-btn {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    opacity: 0;
  }
  .share-image {
    position: fixed;
    left: 50%;
    bottom: 25vh;
    transform: translateX(-50%);
    width: 5.6rem;
    height: 8.3rem;
    border-radius: 0.2rem;
    background: rgb(255, 165, 0);
    z-index: 999;
    border: 1px solid orange;
    transition: all 0.5s;
    opacity: 0;
    display: none;
    > img {
      width: 5.6rem;
      height: 8.3rem;
    }
  }
  .opacity {
    opacity: 1;
    display: block;
  }
}

/* 砍价成功弹窗 */
.bargain-modal {
  .icon-sun {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    display: block;
    width: 7.5rem;
    height: 7.57rem;
  }
  .bargain-content {
    width: 5.8rem;
    // height: 5.8rem;
    background: #fff;
    position: fixed;
    top: 3.47rem;
    left: 50%;
    z-index: 100;
    transform: translateX(-50%);
    border-radius: 0.22rem;
    .icon-bargain {
      display: block;
      width: 1.72rem;
      height: 1.72rem;
      position: absolute;
      top: -0.86rem;
      left: 50%;
      transform: translateX(-50%);
    }
    .bargain-content-save {
      display: flex;
      justify-content: center;
      padding-top: 1.29rem;
      font-size: 0.32rem;
      color: #222;
      font-weight: 600;
    }
    .bargain-content-save-text:first-child {
      margin-right: 0.2rem;
    }
    .bcst-money {
      color: #ff3030;
    }
    .bargain-content-integral {
      margin-top: 0.48rem;
      font-size: 0.24rem;
      color: #222;
      text-align: center;
    }
    .bargain-content-integral-text {
      margin-bottom: 0.18rem;
      .bcit-num {
        color: #ff9000;
      }
    }
    .bargain-content-handle {
      display: flex;
      justify-content: space-between;
      padding: 0 0.65rem .8rem;
      margin-top: 0.83rem;
      .bch-btn {
        width: 2.1rem;
        height: 0.73rem;
        text-align: center;
        line-height: 0.73rem;
        border-radius: 0.08rem;
        font-size: 0.28rem;
        &:first-child {
          background: rgba(255, 255, 255, 1);
          border: 0.01rem solid rgba(237, 237, 237, 1);
          color: #333;
        }
        &:last-child {
          background: linear-gradient(
            90deg,
            rgba(255, 46, 31, 1),
            rgba(252, 81, 0, 1)
          );
          color: #fff;
        }
      }
    }
  }
}
// 购买弹窗
.buy-modal {
  .buy-content {
    width: 5.8rem;
    height: 4.8rem;
    position: fixed;
    top: 30vh;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border-radius: 0.22rem;
    text-align: center;
    z-index: 100;
  }
  .bm-close {
    display: block;
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    right: 0.3rem;
    top: 0.3rem;
  }
  .bm-text1 {
    padding-top: 0.92rem;
    font-size: 0.32rem;
    font-weight: 600;
    color: rgba(34, 34, 34, 1);
    line-height: 0.4rem;
  }
  .bm-text2 {
    font-size: 0.26rem;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    line-height: 0.48rem;
    padding: 0.48rem 0.92rem 0;
  }

  .bm-handle {
    display: flex;
    justify-content: space-between;
    padding: 0 0.65rem;
    margin-top: 0.8rem;
  }
  .bmh-btn {
    text-align: center;
    line-height: 0.73rem;
    width: 2.1rem;
    height: 0.73rem;
    color: #ffffff;
    font-size: 0.28rem;
    background: linear-gradient(
      90deg,
      rgba(255, 46, 31, 1),
      rgba(252, 81, 0, 1)
    );
    border-radius: 0.08rem;
  }
}

// 弹窗按钮
.pagination {
  padding: 0 1.6rem;
  display: flex;
  justify-content: space-around;
}
// 规格弹窗
.tag-modal {
  .popup-content {
    padding: .5rem .3rem .1rem;
    .tag-item {
      display: flex;
      align-items: center;
      font-size: .26rem;
      margin-bottom: .3rem;
      .tag-title {
        margin-right: 1rem;
        color: #999999;
        min-width: 1rem;
        text-align: right;
      }
    }
  }
}
.pagination .page-btn {
  width: 1.5rem;
  height: 0.8rem;
  border-radius: 0.12rem;
  background: #fff;
  border: 0.01rem solid #eee;
  font-size: 0.28rem;
  text-align: center;
  line-height: 0.8rem;
  margin-bottom: 0.2rem;
}
.popup {
    /* position: relative; */
    // height: 4rem;
    position: fixed;
    right: 0;
    left: 0;
    bottom: -100%;
    background: #fff;
    z-index: 999;
    transition: all 0.5s;
    border-radius: 0.25rem 0.25rem 0 0;

  .title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3rem;
    color: #999;
    margin-top: .5rem;
    &::after,
    &::before {
      content: "";
      display: block;
      width: 0.6rem;
      height: 1px;
      background: #ededed;
    }
    &::after {
      margin-left: 0.18rem;
    }
    &::before {
      margin-right: 0.2rem;
    }
  }
    .popup-wrap {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
    }
    .close {
      width: 100%;
      height: 0.9rem;
      text-align: center;
      line-height: 0.9rem;
      color: #333;
      font-size: 0.28rem;
      border-top: 0.1rem solid #f5f5f5;
    }
    .popup-content {
      width: 100%;
      box-sizing: border-box;
    }
}
.open {
  bottom: 0;
}
.share-canvas {
  width: 5.6rem;
  height: 8.3rem;
  position: fixed;
  bottom: 3.5rem;
  left: 50%;
  z-index: 9999;
  transform: translateX(-50%);
  background: linear-gradient(
    114deg,
    rgba(255, 56, 56, 1),
    rgba(255, 138, 0, 1)
  );
  box-shadow:0 .12rem .36rem 0 rgba(0, 0, 0, 0.12);
  > .share-canvas-img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.bargain-content-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.24rem;
    color: #888;
    margin-top: .5rem;
    &::after,
    &::before {
      content: "";
      display: block;
      width: 0.74rem;
      height: 1px;
      background: #ededed;
    }
    &::after {
      margin-left: 0.18rem;
    }
    &::before {
      margin-right: 0.2rem;
    }
}

.close-img {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -1.2rem;
  width: .8rem;
  height: .8rem;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.link-order-info {
  font-size: .24rem;
  color: #333;
}
.bargain-title {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/Bargaining.vue